/**
 * announcement.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, Input } from "@angular/core";
import { Announcement } from "./announcement";

import { Modal } from "angular2-modal/plugins/bootstrap";
import { ModalHelpers } from "../support/utilities";
import { AlertService } from "./alert.service";
import { ChangelogModalComponent } from "./changelog-modal.component";

@Component({
  selector: "announcements",
  template: `
    <div
      *ngIf="current"
      class="alert"
      [class.alert-info]="current.style === 'info'"
      [class.alert-success]="current.style === 'success'"
      [class.alert-warning]="current.style === 'warning'"
      [class.alert-danger]="current.style === 'danger'">
      <span class="oneline-ellipsis">
        <strong>{{current.title}}:</strong>
        <span [innerHtml]="current.content"></span>
      </span>
      <a class="alert-link pull-right" (click)="openChangelog()">
        View Changelog
      </a>
    </div>
  `,
  styles: [
    `.alert-link {
      /* to global css */
      text-decoration: underline;
    }
    .alert {
      height: 50px;
    }
    .alert span {
      width: calc(100% - 125px);
    }`
  ]
})
export class AnnouncementComponent
{
	@Input()
	public unauthed : boolean = false;

  public current : Announcement;

  public all : Announcement[];

  public constructor (protected modal : Modal, protected alerts : AlertService)
  {
    this.alerts.announcementsLoaded.subscribe((loaded : true) => {
			if (this.alerts.userAnnouncements.length > 0)
			{
				this.current = this.alerts.userAnnouncements[0];
			}
		});
  }

  public openChangelog () : void
  {
    ModalHelpers.openCustom(
      this.modal,
      ChangelogModalComponent,
      {size: "lg", title: "Changelog"}
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/common/announcement.component.ts